import { Dictionary } from '@ngrx/entity'
import { createFeatureSelector, createSelector } from '@ngrx/store'

import { CompetitionBlacklist } from './competition-blacklist'
import * as fromCompetitionBlacklist from './competition-blacklist.reducer'

const state =
  createFeatureSelector<fromCompetitionBlacklist.CompetitionBlacklistState>(
    fromCompetitionBlacklist.FEATURE_NAME
  )

const adapter = fromCompetitionBlacklist.adapter.getSelectors()

const selectIds = createSelector(state, adapter.selectIds)
const selectAll = createSelector(state, adapter.selectAll)
const selectEntities = createSelector(state, adapter.selectEntities)
const selectIsLoading = createSelector(state, (state) => state.isLoading)

const selectState = createSelector(state, (state) => state && state)

const selectById = createSelector(
  selectEntities,
  (entities: Dictionary<CompetitionBlacklist>, id: number) => {
    return entities[id]
  }
)

const selectByFilter = createSelector(
  selectAll,
  (
    entities: CompetitionBlacklist[],
    filter?: { field: string; value: string | number }
  ) => {
    if (filter) {
      return entities.filter((entity) => entity[filter.field] == filter.value)
    }

    return entities
  }
)

const selectCount = createSelector(
  selectAll,
  (entities) => entities && entities.length
)

const selectCurrentBlackListObjects = createSelector(selectState, (params) => {
  return params.currentBlackListSelected
})

const selectPaginationDetails = createSelector(
  state,
  (state) => state.paginationDetails
)

export const competitionBlacklistSelectors = {
  selectState,
  selectIsLoading,
  selectById,
  selectIds,
  selectEntities,
  selectAll,
  selectByFilter,
  selectCount,
  selectCurrentBlackListObjects,
  selectPaginationDetails
}
